<template>
  <div>
    <!-- modal para mostrar ao usuario como desativar o modo lite-->
    <div v-if="modal_inf_modo_lite" 
      @click="modal_inf_modo_lite = false"
      style="display: block; padding-top: 200px" 
      class="w3-modal " v-cloak>
      <div class="w3-modal-content" style="font-size:4vw;" @click.stop>
        <div class="w3-container ">
          <span
            @click="modal_inf_modo_lite = false"
            class="w3-button w3-display-topright">&times;
          </span>
          <div class="w3-col" style="padding:0px;">
            <div class="w3-text-theme w3-col s12 m12 l12">
              <strong>
                <strong>Para desativar:</strong>
                <li>1- No canto superior direito, clique <i class="fas fa-ellipsis-v"></i> e depois Configurações.</li>
                <li>2- Em "Avançado", toque em Modo Lite.</li>
                <li>3- Desative o Modo Lite.</li>
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <center v-if="modo_lite">
      <div 
        @click="modal_inf_modo_lite = true" 
        class="w3-text-yellow w3-col" 
        style="font-size:11px; position:fixed; background-color:#9c1d1c; ">
        <label style="text-decoration: underline;">Modo Lite ativo</label>
      </div>
    </center>
    
    <div 
      v-if="processando" 
      style="display: block; padding-top: 0px; background-color:#9c1d1c; position:relative;" 
      v-cloak>
      <div style="font-size: 15px; height: 45px; border-radius:0px;" @click.stop>
        <div class="w3-container w3-center" style="padding:0px;">
          <div class="w3-col" style="padding:0px;">
            <center>
              <div>
                <strong class="w3-text-orange"> 
                  Sem conexão... <i class="fa fa-plug" aria-hidden="true"></i>!
                </strong>
              </div>
            </center>
              
            <div class="sk-conexao w3-col " style="padding:0px">
              <div class="conexao"></div>
            </div>
              
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  export default {
    name: 'ChecarDispositivo',
    data () {
      return {
        processando: false,
        modal_inf_modo_lite: false,
      
        /*dados do dispositivo*/
        dados_dispositivo: '',
        geolocalizacao: '',
        tipo_rede: '',
        economia_de_dados: '',
        tipo_conexao: '',
        velocidade_transferencia_dados: '',
        latencia: '',
        modo_lite: false,
        memoria_do_dispositivo: '',
        plataforma: '',
        
        protocolo:'',
        tem_ssl: false,
        
      }
    },
    mounted(){
      setInterval(() => {
        this.coletarDadosDispositivo()
      }, 2000)
      this.verificarProtocolo()
    },
  
    methods: {
      verificarProtocolo(){
        this.protocolo = window.location.href.indexOf("https")
        this.protocolo >= 0 ? this.tem_ssl = true : this.tem_ssl = false;
      },

      coletarDadosDispositivo(){
        this.memoria_do_dispositivo = Biblioteca.buscarMemoriaRamDispositivo();
        this.geolocalizacao = Biblioteca.buscarGeolocalizacaoDispositivo();
        this.plataforma = Biblioteca.buscarPlataformaDispositivo();
        this.dados_dispositivo = Biblioteca.buscarAplicativoVersaoDispositivo();
        this.tipo_conexao = Biblioteca.buscarTipoConexaoDispositivo();
        this.velocidade_transferencia_dados = Biblioteca.buscarVelocidadeDownloadDispositivo();
        this.latencia = Biblioteca.buscarDadosLatenciaDispositivo();
        this.tipo_rede = Biblioteca.buscarTipoRedeDispositivo();
        this.modo_lite = Biblioteca.buscarModoEconomiaDadosDispositivo();
        /*se houver ssl não vai apresentar o modo lite*/
        this.tem_ssl? this.modo_lite = false : '';
        
        if(Biblioteca.buscarStatusRedeDispositivo()){
          this.processando = false;
        }else{
          this.processando = true;
        } 
      }
    }
  }

</script>

<style scoped>

  .sk-conexao {
    width: 100%;
    height: 10px;
    position: relative;
    animation: sk-conexao 2.5s infinite linear both;
  }
  
  .conexao {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0; 
    animation: conexao 2.0s infinite ease-in-out both; 
  }

  .conexao:before {
    content: '';
    display: block;
    width: 100%;
    height: 25%;
    background-color: white;
    border-radius: 0%;
    animation: conexao-before 2.0s infinite ease-in-out both; 
  }

  .conexao:nth-child(1) { animation-delay: -1.1s; }
  .conexao:nth-child(2) { animation-delay: -1.0s; }
  .conexao:nth-child(3) { animation-delay: -0.9s; }
  .conexao:nth-child(4) { animation-delay: -0.8s; }
  .conexao:nth-child(5) { animation-delay: -0.7s; }
  .conexao:nth-child(6) { animation-delay: -0.6s; }
  .conexao:nth-child(1):before { animation-delay: -1.1s; }
  .conexao:nth-child(2):before { animation-delay: -1.0s; }
  .conexao:nth-child(3):before { animation-delay: -0.9s; }
  .conexao:nth-child(4):before { animation-delay: -0.8s; }
  .conexao:nth-child(5):before { animation-delay: -0.7s; }
  .conexao:nth-child(6):before { animation-delay: -0.6s; }
  
  @keyframes sk-conexao {
    100% { } 
  }
  
  @keyframes conexao {
    80%, 100% {  } 
  }
  
  @keyframes conexao-before {
    50% {
      background-color: #f3f3f3;
    }
    75% {
      background-color: #ddd;
    }
    100%, 0% {
      background-color: darkgrey; 
    } 
  }
    
</style>



// WEBPACK FOOTER //
// src/components/ChecarDispositivo.vue